module.exports = __webpack_public_path__ + "static/media/port-photo.dd387d84.png";